export default __webpack_public_path__ + "static/media/iconoQuote.2ace9a5b.svg";